"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Divider: function() {
        return _index.Divider;
    },
    dividerClassNames: function() {
        return _index.dividerClassNames;
    },
    renderDivider_unstable: function() {
        return _index.renderDivider_unstable;
    },
    useDividerBase_unstable: function() {
        return _index.useDividerBase_unstable;
    },
    useDividerStyles_unstable: function() {
        return _index.useDividerStyles_unstable;
    },
    useDivider_unstable: function() {
        return _index.useDivider_unstable;
    }
});
const _index = require("./components/Divider/index");
